import React from 'react';
import './LeftColumn.css';

const LeftColumn = ({ activeSection, setActiveSection }) => {
    return (
        <div className='leftColumn'>
            <div className={activeSection != 'home' ? 'leftColBtn' : 'activatedBtn'} onClick={() => setActiveSection('home')}>
                Home
            </div>
            <div className={activeSection != 'projects' ? 'leftColBtn' : 'activatedBtn'} onClick={() => setActiveSection('projects')}>
                Projects
            </div>
            <div className={activeSection != 'users' ? 'leftColBtn' : 'activatedBtn'} onClick={() => setActiveSection('users')}>
                Users
            </div>
            <div className={activeSection != 'feedback' ? 'leftColBtn' : 'activatedBtn'} onClick={() => setActiveSection('feedback')}>
                Feedback
            </div>
            <div className={activeSection != 'AI' ? 'leftColBtn' : 'activatedBtn'} onClick={() => setActiveSection('AI')}>
                NLP
            </div>
        </div>
    );
};

export default LeftColumn;
